module.exports = __webpack_public_path__ + "img/work-details-icon.6c498adc.svg";